import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgbDate, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Utils } from '../utils/utils';
import { ClientEmployments } from 'src/app/models/client-employments';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AccountService } from 'src/app/application/account/account.service';
import { ShareService } from '../services/share-service';

@Component({
  selector: 'app-client-employment-popup',
  templateUrl: './client-employment-popup.component.html',
  styleUrls: ['./client-employment-popup.component.scss']
})
export class ClientEmploymentPopupComponent {

  @ViewChild('content') employmentView !: ElementRef
  @Output() dataAdded: EventEmitter<void> = new EventEmitter<void>();

  constructor(private modalService: NgbModal, private apiService:AccountService,private shareService: ShareService,
    private ngbDateParserFormatter: NgbDateParserFormatter) { }

  ngOnInit(): void {
    this.loadEmploymentTypes();
    this.loadEmployers();
  }

  errormessage = '';
  errorclass = '';
  saveresponse: any;
  employmentData: ClientEmployments;
  editdata: any;
  employmentTypes:any;
  employers:any;
  selected_start_date: NgbDate;
  start_date: string;
  selected_end_date: NgbDate;
  end_date: string;

  public selectedDate: NgbDate;
  public dateObject: Date;

  employmentform = new FormGroup({
    id:new FormControl(),
    client_id: new FormControl(),
    employment_start_date: new FormControl('', Validators.compose([Validators.required])),
    employment_end_date: new FormControl(),
    employer_id: new FormControl(),
    employment_type: new FormControl()
  });

  saveEmployment(){
    if(this.employmentform.valid){
      // console.log("employment data "+JSON.stringify(this.employmentform.value));
      this.employmentData = new ClientEmployments(this.employmentform.value);
      this.employmentData.client_id = this.shareService.getLinkedClientId();
      
      this.employmentData.employment_start_date = this.start_date;
      this.employmentData.employment_end_date =this.end_date;

      // console.log("relation data "+JSON.stringify(this.relationData));

      this.apiService.saveClientEmployment(this.employmentData).then(res =>{
        // console.log("response "+JSON.stringify(res));
        if(res["status"] == 1){
          this.closeModalForm();
          // this.
          this.dataAdded.emit();
        }
      })
    }
    else{
      this.errormessage = "Please enter valid data";
      this.errorclass = "errormessage";
    }
  }

  loadEditData(id: any){
    this.openModalForm();
    this.apiService.getClientEmployment(id).then(result => {
      console.log("employment details "+JSON.stringify(result));
      console.log("employers "+JSON.stringify(this.employers));
      var employment = result["data"];

      const employmentStartDate = NgbDate.from(this.ngbDateParserFormatter.parse(employment.employment_start_date));
      const employmentEndDate = NgbDate.from(this.ngbDateParserFormatter.parse(employment.employment_end_date));

      this.employmentform.patchValue(
        { id:employment.id,
          // employment_start_date: employmentStartDate,
          employment_end_date: employmentEndDate,
          employer_id: employment.employer_id,
          employment_type: employment.employment_type
      });
      this.updateStartDate(employmentStartDate);
      this.updateEndDate(employmentEndDate);
    });
  }

  deleteEmployment(id:number){
    this.apiService.deleteClientEmployment(id).then(result=>{
      if(result["status"] == 1){
        // this.closeModalForm();
        this.dataAdded.emit();
      }
    })
  }

  updateStartDate(date: NgbDate){
    this.start_date = Utils.yearMonthDay(new Date(date.year,date.month,date.day));
  }

  updateEndDate(date: NgbDate){
    this.end_date = Utils.yearMonthDay(new Date(date.year,date.month,date.day));
  }



  openModalForm(){
    this.clearForm();
    this.modalService.open(this.employmentView,{ ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModalForm(){
    this.clearForm();
    this.modalService.dismissAll();
  }

  clearForm(){
  //   this.employmentform.patchValue({id:null,relation_name:"",relation_start_date:"",relation_end_date:"",relation_phone:"",relation_type:"",
  // relation_address:""});
  }

  loadEmploymentTypes(){
    this.apiService.getEmploymentTypesDll().then(res => {
      this.employmentTypes = res;
    });
    // console.log("rel types "+this.relationTypes);
  }

  loadEmployers(){
    this.apiService.getEmployers().then(res =>{
      this.employers = res;
      // console.log("res "+JSON.stringify(this.employers))
    })
  }
}

